import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss'],
  standalone: false
})
export class ImageViewerComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { imageSrc: string },
    public dialogRef: MatDialogRef<ImageViewerComponent>
  ) { }
}
